"use client";

import { useEffect } from "react";
import { identify } from "@/analytics/identify";

/**
 * Client component that identifies the user with the client-side Segment SDK.
 * Renders nothing — just calls identify() on mount so all subsequent
 * client-side track() calls include the user identity.
 */
export function AnalyticsIdentify({ userId }: { userId: string }) {
  useEffect(() => {
    identify(userId);
  }, [userId]);

  return null;
}
